"use strict";

export default {
  TEAMLEITER: "ff39a9f1-57d3-48e1-bb4a-5a4df3d693a0",
  MITGLIED: "c429cf3a-62da-4103-b048-6f24b0437ceb"
};
